const ALT_TEXT = "common.domain.icon.alt";

export const PLACEHOLDER = "activation.home.header.multiple_sets.place.text";
export const CREATE_NEW = "activation.home.header.multiple_sets.footer.create-new.text";
export const MAXIMUM_TEXT = "activation.home.header.multiple_sets.footer.max.text";
export const MAX_TOOLTIP = "activation.home.header.multiple_sets.footer.max.tooltip.text";
export const NO_RESULT = "activation.home.header.multiple_sets.search.no_result.text";

export const SET_DEFAULT_HP_ICON_TOOLTIP_TEXT = "activation.home.header.multiple_sets.default.hp.tooltip";
